async function setLocalAuth(data, privilege) {
    let authLocal = localStorage.setItem('users', data);
    let authPrivilege = localStorage.setItem('privilege', privilege);
    return [authLocal, authPrivilege];
}

function getLocalAuth() {
    let authLocal = localStorage.getItem('users');
    let authPrivilege = localStorage.getItem('privilege');
    return {
        authLocal: authLocal, authPrivilege: authPrivilege
    };
}

function isLoggedIn() {
    let authLocal = localStorage.getItem('users');

    if (authLocal !== null) {
        return true;
    } else {
        return false;
    }
}

function logout() {
    return localStorage.clear();
}

export { setLocalAuth, getLocalAuth, isLoggedIn, logout }